<template>
  <form class="messages__chat__form" autocomplete="off" @submit.prevent="send">
    <div class="form_section">
      <label for="message" class="sr_only">{{ label }}</label>
      <TextareaAutogrow
        id="message"
        ref="textarea"
        class="test-message_textarea_wrapper"
        :value="message"
        :placeholder="placeholder"
        required="true"
        :aria-valid="String(!!trimmedMessage)"
        autocomplete="off"
        :on-input="e => (message = e.target.value)"
        :should-submit-on-enter="true"
        :on-submit="send"
      />
      <div class="messages__chat__form_submit">
        <button class="btn btn--secondary btn--small" :disabled="!trimmedMessage" type="submit">
          {{ i18n.$gettext('Send') }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions } from 'vuex'
import TextareaAutogrow from '../../../components/TextareaAutogrow.vue'
import focusOnRouteChange from './focus_on_route_change'
import { CHAT_HASH } from './route_helpers'

export default {
  name: 'ChatForm',
  components: { TextareaAutogrow },
  mixins: [focusOnRouteChange(['textarea', '$refs', 'textarea'], CHAT_HASH)],
  props: {
    scope: {
      type: String,
      required: true
    },
    partnerId: {
      type: String,
      required: true
    },
    partnerName: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      message: ''
    }
  },
  computed: {
    placeholder() {
      return this.i18n.$gettext('Write a message ...')
    },
    label() {
      return this.i18n.$gettext('Write a message to %{chat_partner_name}', { chat_partner_name: this.partnerName })
    },
    trimmedMessage() {
      return this.message.trim()
    }
  },
  methods: {
    ...mapActions(['sendMessage']),
    setMessage(e) {
      this.message = e.target.value
    },
    send() {
      const body = this.trimmedMessage

      if (body) {
        this.sendMessage({
          scope: this.scope,
          partnerId: this.partnerId,
          body
        })

        this.message = ''
      }
    }
  }
}
</script>
